export const bucket =
  document.domain === "physifit.org" || document.domain === "www.physifit.org"
    ? "physifit.org"
    : "staging-338019";

export const customerCareNumber = "7980355495";
